// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__15tPv","fadeIn":"ScrollToTopButton_fadeIn__2qSl5"};